module.exports = __webpack_public_path__ + "img/character-button-close.da63e047.png";